import React from 'react'
import styles from "../../../../../assets/styles/componentStyles/chatbotStyles/chats.module.scss";
import globalStyles from "../../../../../assets/styles/global.module.scss";
import { Divider, Grid, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import clsx from "clsx"
import { getValueOrDefault } from '../../../../../utils/constants';

interface RetrieveContactActionLogProps {
    actionData: any
} 

const RetrieveContactActionLog: React.FC<RetrieveContactActionLogProps> = (props) => {
    
    const { actionData } = props;

    return (
        <>
            <Grid container className={clsx(styles.retrieveContactActionContainer, globalStyles.flexColumn)} gap={1}>
                <Grid item className={globalStyles.fullwidth}>
                    <Typography className={styles.customAPICallMsgTitle}>
                        Retrieve Contact
                    </Typography>
                </Grid>
                <Divider />

                <Grid item className={globalStyles.fullwidth}>
                    <Grid container flexWrap={"nowrap"} gap={1} flexDirection={"column"}>
                        <Grid item xs={12}>
                            <Grid container gap={"4px"} flexWrap={"nowrap"} alignItems={"center"}>
                                <Grid item xs={4} className={styles.customAPICallInfoTitle}>
                                    Contact List    
                                </Grid> 
                                <Grid item xs={7.5}>
                                    {getValueOrDefault(actionData?.contact_list_name)}
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item xs={12} className={globalStyles.fullwidth}>
                            <TableContainer className={styles.resetVariableTableContainer}>
                                <Table className={styles.resetVariableTable}>
                                    <TableHead>
                                        <TableRow className={styles.resetVariableHeaderTableRow}>
                                            <TableCell className={styles.resetVariableTableHeaderCell}>Variable</TableCell>
                                            <TableCell className={styles.resetVariableTableHeaderCell}>Value</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {actionData?.action_retrieve_contact_variable_execution_data?.map((variable: any, index: number) => (
                                            <TableRow key={index}>
                                                <TableCell className={styles.resetVariableTableBodyCell}>
                                                    {variable?.chatbot_custom_variable_configuration?.chatbot_custom_variable_configuration_name}
                                                </TableCell>
                                                <TableCell className={styles.resetVariableTableBodyCell}>
                                                    {getValueOrDefault(variable?.chatbot_custom_variable_value)}
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </>
    )
}

export default RetrieveContactActionLog
